import Icon from '@forwardflow/ui/Icons'
import { SelectField, TextField } from '@forwardflow/ui'
import { useGetTagsList } from '@forwardflow/hooks/customHooks/stageMapping/tagsList'
import { Form } from 'antd'
import { useGetFubStages } from '@forwardflow/hooks/customHooks/stageMapping'

type AdvanceStageSelectProps = {
   className?: string
   title: string
   children?: React.ReactNode
   description?: string
   key?: string
   data?: any
   stage?: string
   isRequired?: boolean
}

export const AdvanceStageSelect: React.FC<AdvanceStageSelectProps> = ({
   className,
   children,
   title,
   description,
   data,
   stage,
   isRequired,
}) => {
   const { data: leadStages } = useGetFubStages({
      page: 1,
      limit: 10000,
   })
   const leadStageItemsOptions = leadStages?.data?.map((item: any) => ({
      label: item.stageName,
      value: item.stageName,
   }))

   const { data: tags } = useGetTagsList({
      page: 1,
      limit: 3000,
   })
   const tagsOptions = tags?.data?.map((item: any) => ({
      label: item.tagName,
      value: item.tagName,
   }))
   return (
      <>
         <div
            key={data?.stageId}
            className={`flex flex-col  w-full p-[10px] rounded-lg ${className}`}
         >
            <div className="flex md:items-center gap-y-2 flex-col md:flex-row gap-x-2 text-[12px]">
               <div className="flex items-center leading-none text-white gap-x-2">
                  {children}
                  <span className="w-[115px]">{title}</span>
                  <Icon name="arrow-right" className="!fill-white" width={10} />
               </div>

               <div className="flex items-start flex-1 gap-3">
                  {/* Primary Selection  */}
                  <div className="flex-1 flexc shrink-0">
                     <SelectField
                        name={`${stage}PrimarySelection`}
                        formItemClassName="mb-0 flex-1"
                        className="!h-10 border4 bg-white/10 rounded w-full shrink-0"
                        placeholder="Select"
                        allowClear={false}
                        options={[
                           {
                              label: 'Create new stage',
                              value: 'new stage',
                           },
                           {
                              label: 'Create new tag',
                              value: 'new tag',
                           },
                           {
                              label: 'Select existing tag',
                              value: 'tag',
                           },
                           {
                              label: 'Select existing stage',
                              value: 'stage',
                           },
                        ]}
                     ></SelectField>
                  </div>
                  <Form.Item
                     noStyle
                     dependencies={[`${stage}PrimarySelection`]}
                  >
                     {({ getFieldValue }) => {
                        const selection = getFieldValue(
                           `${stage}PrimarySelection`
                        )
                        return (
                           <div className="flex-1 flexc shrink-0">
                              {selection === 'new stage' && (
                                 <TextField
                                    name={`${stage}NewStage`}
                                    formItemClassName="!mb-0"
                                    placeholder="Enter stage name"
                                    isRequired={isRequired}
                                    errorMessage="Please enter a stage name"
                                    className="!h-10 w-80 !min-h-10 border4 bg-white/10 !rounded !bg-fub_gray_img !bg-no-repeat !bg-[position:10px_center] !pl-8"
                                 />
                              )}

                              {selection === 'new tag' && (
                                 <TextField
                                    name={`${stage}NewTag`}
                                    formItemClassName="!mb-0"
                                    placeholder="Enter tag name"
                                    isRequired={isRequired}
                                    errorMessage="Please enter a tag name"
                                    className="!h-10 w-80 !min-h-10 border4 bg-white/10 !rounded !bg-fub_gray_img !bg-no-repeat !bg-[position:10px_center] !pl-8"
                                 />
                              )}

                              {selection === 'tag' && (
                                 <SelectField
                                    name={`${stage}ExistingTag`}
                                    formItemClassName="mb-0 flex-1 max-w-[214px]"
                                    className="!h-10 border4 rounded shrink-0 fub-stage-select"
                                    placeholder="Select existing tag"
                                    options={tagsOptions}
                                    showSearch
                                    isRequired={isRequired}
                                    errorMessage="Please select a tag"
                                 ></SelectField>
                              )}

                              {selection === 'stage' && (
                                 <SelectField
                                    name={`${stage}ExistingStage`}
                                    formItemClassName="mb-0 flex-1 max-w-[214px]"
                                    className="!h-10 border4 rounded shrink-0 fub-stage-select "
                                    placeholder="Select existing stage"
                                    options={leadStageItemsOptions}
                                    showSearch
                                    isRequired={isRequired}
                                    errorMessage="Please select a stage"
                                 ></SelectField>
                              )}
                           </div>
                        )
                     }}
                  </Form.Item>
               </div>
            </div>

            <p className="text-[12px] text-[#D2D2D2]/70 max-w-[584px] mt-3 pl-4">
               {description}
            </p>
         </div>
      </>
   )
}
